"use client";

import Image from "next/image";
import React, { useState } from "react";
import RichText from "payload-pms/RichText";
const styles = new Proxy({"AccordionContainer":"AccordionContainer-2f0ee","Title":"Title-2f0ee","Table":"Table-2f0ee","TableRow":"TableRow-2f0ee","TableSide":"TableSide-2f0ee","OnlyDesktop":"OnlyDesktop-2f0ee","OnlyMobile":"OnlyMobile-2f0ee","MobileAccordion":"MobileAccordion-2f0ee","mobileRow":"mobileRow-2f0ee","Grey":"Grey-2f0ee","MobileTabContent":"MobileTabContent-2f0ee"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./Accordion.scss";*/

export type AccordionItem =
  | {
      title: string;
      ctaLabel: string;
      ctaHref: string;
      type: "comparison";
      content: {
        titleLeft: string;
        titleRight: string;
        rows: {
          textLeft?: string;
          textRight?: string;
          imgTitle?: string;
          img?: {
            url: string;
            width?: number;
            height?: number;
            alt?: string;
          };
        }[];
      };
    }
  | {
      title: string;
      ctaLabel: string;
      ctaHref: string;
      type: "list";
      list: {
        title: string;
        content: { item?: string; id: string }[];
      }[];
    }
  | {
      ctaLabel: string;
      ctaHref: string;
      type: "card";
      richContent: any;
      title: string;
    };

export type AccordionClientProps = {
  title: string;
  items: AccordionItem[];
};

const AccordionClient: React.FC<AccordionClientProps> = ({ title, items }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <>
      <h2 className={`mb-4 mx-auto ${styles.Title}`}>{title}</h2>
      <div className={`accordion py-5 ${styles.OnlyDesktop}`}>
        {items.map((item, index) => {
          return (
            <div
              key={`${item.title}-${index}`}
              className={`accordion-item ${index === activeIndex ? "active" : ""}`}
              onClick={() => toggleAccordion(index)}
            >
              <div className="accordion-title">{item.title}</div>
              <div className="accordion-content">
                {(() => {
                  if (item.type === "list") {
                    const { list, ctaHref, ctaLabel } = item;

                    return (
                      <div>
                        <div className="row">
                          {list.map((item, idx) => (
                            <div key={idx} className="col-6">
                              <h4>{item.title}</h4>
                              <ul>
                                {item.content?.length > 0 &&
                                  item.content.map((e) => (
                                    <li key={e.id}>{e.item || ""}</li>
                                  ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                        {ctaLabel && ctaHref && (
                          <div className="row mt-5 text-center">
                            <a
                              href={ctaHref}
                              className="mainlink d-block w-auto mx-auto"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {ctaLabel}
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  } else if (item.type === "card") {
                    const { richContent, ctaLabel, ctaHref } = item;
                    return (
                      <div className="container py-3">
                        <div className="row text-center mb-4 px-5">
                          <RichText content={richContent} />
                        </div>
                        {ctaLabel && ctaHref && (
                          <div className="row mt-5 text-center">
                            <a
                              href={ctaHref}
                              className="mainlink d-block w-auto mx-auto"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {ctaLabel}
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  }
                  const { content, ctaHref, ctaLabel } = item;
                  const usedContentRows = content.rows.filter(
                    (row) =>
                      row?.img?.url &&
                      row.imgTitle &&
                      row.textLeft &&
                      row.textRight,
                  );
                  return (
                    <div className="container py-3">
                      <div className="row text-center mb-4">
                        <div className="col-5">
                          <h4>{content.titleLeft}</h4>
                        </div>
                        <div className="col-2" />
                        <div className="col-5">
                          <h4>{content.titleRight}</h4>
                        </div>
                      </div>

                      {usedContentRows.map((row: any) => (
                        <div className="row mb-3" key={row.imgTitle}>
                          <div className="col-md-5 py-2 text-center hexagon-col-left">
                            <div className="hexagon hexagon-left">
                              <h4>{row.textLeft} </h4>
                            </div>
                          </div>
                          <div className="col-md-2 py-2 px-0">
                            <div className="text-center">
                              <Image
                                src={row.img.url}
                                alt={row.img.alt}
                                width={row.img.width}
                                height={row.img.height}
                                sizes="87px"
                                style={{
                                  maxWidth: "87px",
                                  width: "100%",
                                  height: "auto",
                                }}
                              />
                              <p
                                className="mt-2"
                                style={{
                                  color: "#fff",
                                  fontFamily: "Poppins, sans-serif",
                                  fontSize: "14px",
                                  margin: 0,
                                }}
                              >
                                {row.imgTitle}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-5 py-2 text-center hexagon-col-right">
                            <div className="hexagon hexagon-right">
                              <h4>{row.textRight}</h4>
                            </div>
                          </div>
                        </div>
                      ))}
                      {ctaHref && ctaLabel && (
                        <div className="row mt-5 text-center">
                          <a
                            href={ctaHref}
                            className="mainlink d-block w-auto mx-auto"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {ctaLabel}
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.OnlyMobile}>
        <div className={`accordion ${styles.MobileAccordion}`}>
          {items.map((tab, idx) => {
            const isOpen = idx === activeIndex;
            return (
              <div
                key={idx}
                className={`accordion-item ${isOpen ? "active" : ""} mb-3`}
                onClick={() => toggleAccordion(idx)}
              >
                <div className="accordion-title">{tab.title}</div>
                {isOpen && (
                  <div className="accordion-content">
                    {(() => {
                      if (tab.type === "list") {
                        return (
                          <>
                            {tab.list.map((item, i) => (
                              <div key={i} className={styles.mobileRow}>
                                <h4>{item.title}</h4>
                                <ul>
                                  {item.content?.length > 0 &&
                                    item.content.map((e) => (
                                      <li key={e.id}>{e.item || ""}</li>
                                    ))}
                                </ul>
                              </div>
                            ))}
                          </>
                        );
                      }
                      if (tab.type === "card") {
                        const { richContent, ctaLabel, ctaHref } = tab;
                        return (
                          <div className={styles.MobileTabContent}>
                            <RichText content={richContent} />
                            {ctaLabel && ctaHref && (
                              <div className="text-center mt-4">
                                <a
                                  href={ctaHref}
                                  className="mainlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {ctaLabel}
                                </a>
                              </div>
                            )}
                          </div>
                        );
                      }
                      const {
                        content: { titleLeft, titleRight, rows },
                      } = tab;
                      const usedRows = rows.filter(
                        (row) =>
                          row?.img?.url &&
                          row.imgTitle &&
                          row.textLeft &&
                          row.textRight,
                      );
                      return (
                        <>
                          {usedRows.map((row: any, i: number) => (
                            <div key={i} className={styles.mobileRow}>
                              <h3>{row.imgTitle}</h3>
                              <h4>{titleLeft}</h4>
                              <p>{row.textLeft}</p>
                              <h4 className={styles.Grey}>{titleRight}</h4>
                              <p className={styles.Grey}>{row.textRight}</p>
                            </div>
                          ))}
                        </>
                      );
                    })()}
                    {tab.type !== "card" && tab.ctaLabel && tab.ctaHref && (
                      <div className="text-center mt-4">
                        <a
                          href={tab.ctaHref}
                          className="mainlink"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {tab.ctaLabel}
                        </a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default AccordionClient;
